export default "__VITE_ASSET__DyqwZbU6__"